import { Pipe, PipeTransform } from '@angular/core';
import { Notification } from '@platform-frontend/util';
import { ActionFilter, InclusiveActionFilter } from '../loading';

@Pipe({
  name: 'asActionFilter'
})
export class AsActionFilterPipe implements PipeTransform {
  transform(value: Notification): ActionFilter {
    return new InclusiveActionFilter(...value.options.spinnerInclusiveActions);
  }
}
